<dx-popup
    #apBillDetailPopup
    [title]="popUpTitle"
    [showTitle]="true"
    [minWidth]="'50%'"
    [minHeight]="'50%'"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" class="ap-bill-content">
        <dx-box *ngIf="!!apBillData" width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <dx-form
                    width="100%"
                    height="100%"
                    [readOnly]="true"
                    [labelLocation]="defaultLabelLocation"
                    [colCount]="1"
                    [formData]="apBillData"
                >
                    <dxi-item itemType="group" [colCount]="2">
                        <dxi-item>
                            <dxo-label text="Bill Date"></dxo-label>
                            <div *dxTemplate>
                                {{ apBillData?.billDate | date: dateFormat }}
                            </div>
                        </dxi-item>
                        <dxi-item itemType="group" [colCount]="2">
                            <dxi-item>
                                <dxo-label text="Post Date"></dxo-label>
                                <div *dxTemplate>
                                    {{ apBillData?.postDate | date: dateFormat }}
                                </div>
                            </dxi-item>
                            <dxi-item *ngIf="isInternal">
                                <div *dxTemplate class="history-icon">
                                    <dx-toolbar>
                                        <dxi-item
                                            location="after"
                                            widget="dxButton"
                                            locateInMenu="auto"
                                            [options]="historyButtonOptions"
                                        ></dxi-item>
                                    </dx-toolbar>
                                </div>
                            </dxi-item>
                            <dxi-item itemType="empty" *ngIf="!isInternal"></dxi-item>
                        </dxi-item>

                        <dxi-item>
                            <dxo-label text="Due Date"></dxo-label>
                            <div *dxTemplate>
                                <span>{{ apBillData?.dueDate | date: dateFormat }}</span>
                            </div>
                        </dxi-item>

                        <dxi-item>
                            <dxo-label text="Payee"></dxo-label>
                            <div *dxTemplate>
                                <app-hyperlink-creator
                                    actionCode="VENDOR_MANAGEMENT"
                                    [communityId]="apBillData?.communityId"
                                    [displayText]="apBillData?.vendorName"
                                    (onLinkClick)="onVendorNameClick(apBillData)"
                                ></app-hyperlink-creator>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Amount"></dxo-label>
                            <div *dxTemplate>
                                <span *ngIf="apBillData.amount === 0">
                                    {{ currencyFormatter(apBillData?.amount) }}
                                </span>
                                <span *ngIf="apBillData.amount !== 0">
                                    <app-hyperlink-creator
                                        mode="hyperlinkOnly"
                                        [communityId]="apBillData?.communityId"
                                        [displayText]="currencyFormatter(apBillData?.amount)"
                                        (onLinkClick)="showAPCreditApplication()"
                                    ></app-hyperlink-creator>
                                </span>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Open Balance"></dxo-label>
                            <div *dxTemplate>
                                <span>{{ apBillData?.openBalance | ccCurrency }}</span>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="apBillData?.description">
                            <dxo-label text="Bill Description"></dxo-label>
                            <div *dxTemplate>
                                <span>{{ apBillData?.description }}</span>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="apBillData?.wfJobId">
                            <dxo-label text="AAP Workflow Job ID #"></dxo-label>
                            <div *dxTemplate>
                                <!-- Showing Workflow (Read Only) hence showing hyperlinkOnly-->
                                <app-hyperlink-creator
                                    actionCode="WORKFLOW_DETAILS"
                                    [communityId]="apBillData?.communityId"
                                    [displayText]="apBillData?.wfJobId"
                                    (onLinkClick)="onWorkflowIdClick()"
                                ></app-hyperlink-creator>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="apBillData?.supportingDocument.downloadUrl">
                            <dxo-label text="Supporting Document"></dxo-label>
                            <div *dxTemplate>
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    textLocation="right"
                                    [displayText]="apBillData.supportingDocument.fileName"
                                    [communityId]="apBillData?.communityId"
                                    (onLinkClick)="onDownloadClick(apBillData?.supportingDocument)"
                                >
                                    <i
                                        class="cc-1-25x margin-right-3px"
                                        [ngClass]="getFileIconByExtension(apBillData?.supportingDocument)"
                                    ></i>
                                </app-hyperlink-creator>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="apBillData?.billType">
                            <dxo-label text="Bill Type"></dxo-label>
                            <div *dxTemplate>
                                <span>{{ apBillData?.billType }}</span>
                            </div>
                        </dxi-item>
                    </dxi-item>
                    <dxi-item *ngIf="apBillData?.reversedDate">
                        <dxo-label text="Reversed"></dxo-label>
                        <div *dxTemplate>
                            <span class="dx-field-item-required-mark">
                                This Bill has been reversed on {{ apBillData?.reversedDate | date: dateTimeFormat }}
                            </span>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1" class="ap-bill-details-datagrid-content">
                <cc-data-grid-features
                    [stateConfig]="{ storageKey: 'AP_BILL_DETAILS_GRID' }"
                    [gridFeatures]="{
                        placement: 'top',
                        allowPlacementSwitch: false,
                        allowGrouping: isCorporateCirabook
                    }"
                    [pagingConfig]="{ visible: isCorporateCirabook }"
                    [dataSource]="apBillData?.items"
                >
                    <dx-data-grid
                        width="100%"
                        height="100%"
                        [showBorders]="true"
                        [showRowLines]="true"
                        [showColumnLines]="true"
                        [wordWrapEnabled]="true"
                        [rowAlternationEnabled]="false"
                        [columnAutoWidth]="true"
                        [dataSource]="apBillData?.items"
                    >
                        <dxi-column
                            caption="Item #"
                            dataType="string"
                            alignment="right"
                            cellTemplate="itemNoTemplate"
                            width="4%"
                        ></dxi-column>
                        <dxi-column
                            caption="GL Account"
                            dataType="string"
                            dataField="glAccountNumberTitle"
                        ></dxi-column>
                        <dxi-column
                            caption="Offset GL Account"
                            dataType="string"
                            dataField="offsetGLAccountNumberTitle"
                        ></dxi-column>
                        <dxi-column caption="Sub Category" dataType="string" dataField="subCategory"></dxi-column>
                        <dxi-column
                            caption="Amount"
                            dataType="number"
                            dataField="amount"
                            [format]="currencyFormat"
                            [allowGrouping]="false"
                        ></dxi-column>
                        <dxi-column
                            caption="Open Balance"
                            dataType="number"
                            dataField="openBalance"
                            [format]="currencyFormat"
                            [allowGrouping]="false"
                        ></dxi-column>
                        <dxi-column caption="Description" dataType="string" dataField="description"></dxi-column>

                        <dxi-column
                            caption="Dimensions"
                            dataType="string"
                            cellTemplate="dimensionsTemplate"
                        ></dxi-column>

                        <div *dxTemplate="let row of 'itemNoTemplate'">
                            <span>{{ row.rowIndex + 1 }}</span>
                        </div>

                        <div *dxTemplate="let row of 'dimensionsTemplate'">
                            <ng-container *ngFor="let dim of row.data.dimensions">
                                <ng-container>
                                    {{ dim.dimensionTitle }}: {{ dim.dimensionOptionTitle }}
                                    <br />
                                </ng-container>
                            </ng-container>
                        </div>
                    </dx-data-grid>
                </cc-data-grid-features>
            </dxi-item>

            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="after" *ngIf="apBillData?.allowReclassify">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Reclassify"
                                [icon]="iconRandom"
                                (onClick)="onReclassifyClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" *ngIf="apBillData?.allowReverseBill">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Reverse"
                                hint="Reverse"
                                [icon]="iconReverse"
                                (onClick)="onReverseBillClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>

                    <dxi-item location="after" [visible]="apBillData?.allowEdit">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Update Bill"
                                hint="Update Bill"
                                [icon]="iconEdit"
                                (onClick)="onUpdateBillClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="apBillData?.allowDeleteBill">
                        <div *dxTemplate>
                            <dx-button
                                type="danger"
                                text="Delete Bill"
                                hint="Delete Bill"
                                [icon]="iconTrash"
                                (onClick)="onDeleteBillClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                [icon]="iconClose"
                                text="Close"
                                (onClick)="onHidden()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<!-- Workflow Reclassify and Workflow Detail -->
<app-workflow-viewer
    *ngIf="showReclassify || showWorkflowDetail"
    [viewOnly]="showWorkflowDetail"
    [workflowId]="apBillData?.wfJobId"
    [communityId]="apBillData?.communityId"
    [apBillDetailParam]="apBillDetailParam"
    (onClose)="onViewerClose($event)"
></app-workflow-viewer>

<app-transaction-history
    *ngIf="showTransactionLog"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogs"
    [communityId]="apPaymentParam?.communityId"
    (onTransactionLogClose)="onTransactionLogClose()"
></app-transaction-history>

<app-ap-reverse
    *ngIf="showReverseBill"
    [title]="reverseAPTitle"
    [isReasonMandatory]="false"
    [reverseEditorData]="reverseEditorData"
    (onReverse)="onReverseBill($event)"
    (onClose)="onReverseBillClose()"
></app-ap-reverse>

<app-ap-credit-application
    *ngIf="showCreditApplication"
    [visible]="showCreditApplication"
    [creditApplicationData]="creditApplicationData"
    [transactionType]="transactionType"
    [transactionId]="apBillDetailParam.billId"
    [communityId]="apBillDetailParam.communityId"
    [popupTitle]="creditApplicationTitle"
    [managementCompanyId]="apBillDetailParam.managementCompanyId"
    (onCreditApplicationClose)="closeCreditApplication($event)"
></app-ap-credit-application>

<app-service-charge-editor
    *ngIf="showAddServiceChargeEditor"
    [visible]="showAddServiceChargeEditor"
    [popUpTitle]="addServiceChargeTitle"
    [serviceChargeParam]="serviceChargeParam"
    [serviceChargeEditorData]="serviceChargeEditorData"
    [subCategories]="subCategories"
    (getSubcategories)="getSubcategories($event)"
    (addServiceCharge)="addAPServiceCharge($event)"
    (closeServiceChargeEditor)="closeServiceChargePopUp()"
></app-service-charge-editor>

<dx-popup
    #workflowEditorPopup
    *ngIf="showWorkFlowEditor"
    width="99%"
    height="99%"
    [title]="'Update WF Job ' + apBillData?.wfJobId"
    [showTitle]="true"
    [resizeEnabled]="true"
    [visible]="showWorkFlowEditor"
    (onShown)="onWorkflowEditorShown()"
    (onHidden)="onWorkflowEditorClose()"
>
    <div *dxTemplate="let data of 'content'">
        <iframe
            id="frameElement"
            width="100%"
            height="100%"
            class="cc-iframe"
            [title]="'Update WF Job ' + apBillData?.wfJobId"
            [src]="workflowLink | ccSafeUrl"
        ></iframe>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#apBillDetailPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
